import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { buttonClasses } from '../../utils/buttonStyles';
import { MountSwapAnimation } from '../mount/MountSwapAnimation';

/** The Magnetic Mount advantage — one of the strongest selling points on the homepage. */
export function MountTeaser() {
  return <section aria-labelledby="mount-title" className="mf-tech-grid bg-deep" data-id="element-273" data-mp="viz3tp8jby32">
      <div className="mx-auto grid max-w-site items-center gap-10 px-5 py-10 md:px-8 md:py-14 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-274" data-mp="zig7qe8bcn64">
        <div data-id="element-275" data-mp="14k5kpzf3jawu">
          <p className="font-display text-lg uppercase tracking-[0.14em] text-titanium" data-id="element-276" data-mp="19hfgdwt2wit4">Magnetic Mount System™</p>
          <h2 id="mount-title" className="mt-3 font-display text-5xl font-semibold uppercase leading-[0.92] md:text-7xl" data-id="element-277" data-mp="1eh1vkbsgw94k">
            Your lights come off.
            <span className="block text-ice" data-id="element-278" data-mp="3bamytf3zngj8">Your mounts stay put.</span>
          </h2>
          <p className="mt-6 font-display text-xl font-semibold uppercase tracking-[0.06em] text-white md:text-2xl" data-id="element-279" data-mp="3g8ewkprbdwvc">
            One mount. One perfect position. Every time.
          </p>
          <p className="mt-4 max-w-lg text-lg text-titanium" data-id="element-280" data-mp="1v1kv88z4dnd1">
            Install the base once. When the M1 PRO needs charging, lift it off — the base never moves. The charged light,
            or a backup unit, snaps back onto the exact same position.
          </p>
          <dl className="mt-8 space-y-3 border-l-2 border-marine pl-5" data-id="element-281" data-mp="2isgs3kifn8r5">
            <div data-id="element-282" data-mp="2dsufndafhwje">
              <dt className="sr-only" data-id="element-283" data-mp="2dscafr5sg7zc">Main benefit</dt>
              <dd className="font-display text-lg font-semibold uppercase tracking-[0.06em] text-white" data-id="element-284" data-mp="2dtnbhj7un1mr">
                No remounting. No repositioning. No guesswork.
              </dd>
            </div>
            <div data-id="element-285" data-mp="24u8owuuszb7j">
              <dt className="sr-only" data-id="element-286" data-mp="xem4eev3z9n2">Principle</dt>
              <dd className="font-display text-lg font-semibold uppercase tracking-[0.06em] text-ice" data-id="element-287" data-mp="xfdniq7irewg">The mount stays. The light changes.</dd>
            </div>
          </dl>
          <Link to="/magnetic-mount" className={`${buttonClasses('secondary')} mt-8`} data-id="element-288" data-mp="utmnupkutzgg">
            See how it works <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-289" data-mp="ztixb4cbmj3e" />
          </Link>
        </div>
        <MountSwapAnimation compact data-id="element-290" data-mp="kwi2ut2qwa18" />
      </div>
    </section>;
}